import { createAction, props } from '@ngrx/store';
import { UIState } from '../states/ui.state';

/**
 * UI state has changed
 */
export const changed = createAction(
  '[UI] Changed',
  props<UIState>()
);